import { createAction, props } from '@ngrx/store'
import { DataAnalyticsClickSource, DataAnalyticsEventLabel } from '../../../shared/mb-constants'

const ADD_TO_CART = '[MbAnalytics] Add to Cart'
const RESET_CART = '[MbAnalytics] Reset'

export const addToCart = createAction(
  ADD_TO_CART,
  props<{ addToCartSource?: DataAnalyticsClickSource; eventLabel?: DataAnalyticsEventLabel }>()
)

export const resetCart = createAction(
  RESET_CART,
)
